import "./readMoreText.css";
import { useSelector } from "react-redux";
import { useState, useRef, useEffect } from "react";

const ReadMoreText = ({ text = "", limit = 120 }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState("auto");
  const [expanded, setExpanded] = useState(false);
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  const isLongText = text.length > limit;
  const previewText = text.slice(0, limit);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(expanded ? contentRef.current.scrollHeight : 0);
    }
  }, [expanded]);

  if (!text) return null;

  return (
    <div
      className={`read-more-wrapper d-start ${isDarkMode ? "dark" : "light"}`}
    >
      <div className="read-more-content">
        <span ref={contentRef}>
          {expanded ? text : previewText}
          {!expanded && isLongText && "…"}
        </span>
      </div>

      {isLongText && (
        <button
          type="button"
          className="read-more-btn"
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
        >
          {expanded ? (
            <>
              Read less <span className="arrow">▲</span>
            </>
          ) : (
            <>
              Read more <span className="arrow">▼</span>
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default ReadMoreText;
